/**
 * Utility pure per reachability API (origin e health `/up`).
 * Vedi `docs/NETWORK_CONNECTIVITY.md`.
 */

/** Origin dell'API JWT da `environment.API_ENDPOINT` (senza path `/api`). */
export function resolveApiOrigin(apiEndpoint: string): string {
  return new URL(apiEndpoint).origin;
}

/** URL health Laravel (`health: '/up'`). */
export function resolveApiHealthUrl(apiEndpoint: string): string {
  return `${resolveApiOrigin(apiEndpoint)}/up`;
}

/** True se `requestUrl` punta allo stesso origin di `API_ENDPOINT`. */
export function isApiOriginUrl(requestUrl: string, apiEndpoint: string): boolean {
  try {
    const apiOrigin = resolveApiOrigin(apiEndpoint);
    const absolute = new URL(requestUrl, typeof window !== 'undefined' ? window.location.href : apiOrigin);
    return absolute.origin === apiOrigin;
  } catch {
    return false;
  }
}

/** True se la richiesta è il health check `/up` sull'origin API. */
export function isApiHealthCheckUrl(requestUrl: string, apiEndpoint: string): boolean {
  try {
    const apiOrigin = resolveApiOrigin(apiEndpoint);
    const absolute = new URL(requestUrl, typeof window !== 'undefined' ? window.location.href : apiOrigin);
    return absolute.origin === apiOrigin && (absolute.pathname === '/up' || absolute.pathname.endsWith('/up'));
  } catch {
    return false;
  }
}

/**
 * Errore di rete tipico HttpClient (`status === 0`), escludendo abort espliciti.
 */
export function isHttpNetworkError(error: { status?: number; error?: unknown; name?: string }): boolean {
  if (error?.status !== 0) {
    return false;
  }
  const nested = error.error as { name?: string; type?: string } | null | undefined;
  if (nested?.name === 'AbortError' || nested?.type === 'abort') {
    return false;
  }
  if (error.name === 'AbortError') {
    return false;
  }
  return true;
}
